export default {
  SET_INVOICES: function (state, payload) {
    state.invoices = payload;
  },
  SET_SITE_SUMMARY_REPORT: function (state, payload) {
    state.sitesSummaryReport = payload;
  },
  SET_SITE_SUMMARY: function (state, payload) {
    state.sitesSummaries = payload
  }
}
